import {
  MutationFunctionOptions,
  gql,
  useMutation,
} from "@outschool/ui-apollo";
import React from "react";

import {
  CreatePaymentScheduleInput,
  CreatePaymentScheduleMutation,
  CreatePaymentScheduleMutationVariables,
  StopPaymentScheduleInput,
  StopPaymentScheduleMutation,
  StopPaymentScheduleMutationVariables,
} from "../../shared/generated/graphql";

export const CreatePaymentSchedule = gql`
  mutation CreatePaymentSchedule(
    $createPaymentScheduleInput: CreatePaymentScheduleInput!
  ) {
    createPaymentSchedule(
      createPaymentScheduleInput: $createPaymentScheduleInput
    ) {
      uid
      amountCents
      startTime
      nextBillingDate
    }
  }
`;

export function useCreatePaymentSchedule() {
  const [mutate] = useMutation<
    CreatePaymentScheduleMutation,
    CreatePaymentScheduleMutationVariables
  >(CreatePaymentSchedule);
  return React.useCallback(
    async (createPaymentScheduleInput: CreatePaymentScheduleInput) => {
      const { data, errors } = await mutate({
        variables: { createPaymentScheduleInput },
      });
      return {
        errors,
        // @ts-ignore TS(2532): Object is possibly 'undefined'.
        paymentSchedule: data.createPaymentSchedule,
      };
    },
    [mutate],
  );
}

export const StopPaymentSchedule = gql`
  mutation StopPaymentSchedule(
    $stopPaymentScheduleInput: StopPaymentScheduleInput!
  ) {
    stopPaymentSchedule(stopPaymentScheduleInput: $stopPaymentScheduleInput)
  }
`;

export function useStopPaymentSchedule(
  mutationOptions: MutationFunctionOptions<
    StopPaymentScheduleMutation,
    StopPaymentScheduleMutationVariables
  > = {},
) {
  const [mutate] = useMutation<
    StopPaymentScheduleMutation,
    StopPaymentScheduleMutationVariables
  >(StopPaymentSchedule);
  return React.useCallback(
    async (stopPaymentScheduleInput: StopPaymentScheduleInput) => {
      return await mutate({
        variables: { stopPaymentScheduleInput },
        ...mutationOptions,
      });
    },
    [mutate, mutationOptions],
  );
}
